import React, { FunctionComponent, useMemo } from "react";
import { useIntl } from "react-intl";
import FilterGroup from "../FilterGroup";
import SelectFilter from "../SelectFilter";
import Button from "../../../atoms/Button";
import { ColorType } from "../../../../types/bootstrap/BootstrapType";
import { resourceService } from "../../../../services/ResourceService";
import { StaffingReportingSearchFilter } from "../../staffingcalendar/StaffingReporting";
import { activityAreaService } from "../../../../services/ActivityAreaService";
import AutocompleteMultiselect from "../AutocompleteMultiselect";
import { resourceTypeService } from "../../../../services/ResourceTypeService";
import { dateUtils } from "../../../../utils/dateUtils";

interface StaffingReportingFiltersProps {
  searchObject: StaffingReportingSearchFilter,
  initialState: StaffingReportingSearchFilter,
  updateSearchField: (field: string, value: unknown) => void,
  onReset: () => void,
  fetchDataFirstPage: (searchObject: StaffingReportingSearchFilter) => void,
}

const StaffingReportingFilters: FunctionComponent<StaffingReportingFiltersProps> = ({
  searchObject,
  initialState,
  updateSearchField,
  onReset,
  fetchDataFirstPage,
}) => {
  const intl = useIntl()

  const getYearOptions = () => {
    const start = 2015;
    const end = dateUtils.today().getFullYear() + 1;
    const options = [];

    for (let year = start; year <= end; year++) {
      options.push({label: year.toString(), value: year.toString()})
    }

    return options;
  }
  const yearOptions = useMemo(() => getYearOptions(), []);

  return (
    <FilterGroup>
      <SelectFilter
        className="me-2"
        onChange={(value) => updateSearchField("year", value)}
        title={intl.formatMessage({id: "year"})}
        value={searchObject?.year}
        options={yearOptions}
      />

      <AutocompleteMultiselect
        title={intl.formatMessage({id: "staffing_resource"})}
        placeholder={intl.formatMessage({id: "staffing_resource"})}
        values={searchObject.resourceIds ?? []}
        onChange={(values) => updateSearchField("resourceIds", values)}
        fetchData={resourceService.getResourcesPage}
        filterFieldName="identity.lastName,identity.firstName"
        labelJoiner=" "
        filterFieldSearch="nameSurname"
        className="me-2"
        classNameLabel="mb-1 fw-bold"
      />

      <AutocompleteMultiselect
        title={intl.formatMessage({id: "resource_table_header_area"})}
        placeholder={intl.formatMessage({id: "resource_table_header_area"})}
        values={searchObject.activityAreas ?? []}
        onChange={(values) => updateSearchField("activityAreas", values)}
        fetchData={activityAreaService.getActivityAreasPage}
        filterFieldName="label"
        className="me-2"
        classNameLabel="mb-1 fw-bold"
      />

      <AutocompleteMultiselect
        title={intl.formatMessage({id: "resource_type"})}
        placeholder={intl.formatMessage({id: "resource_type"})}
        values={searchObject.resourceTypeIds ?? []}
        onChange={(values) => updateSearchField("resourceTypeIds", values)}
        fetchData={resourceTypeService.getResourceTypePage}
        filterFieldName="label"
        className="me-2"
        classNameLabel="mb-1 fw-bold"
      />

      <div className="d-flex ms-2">
        <Button onClick={() => {
          onReset()
          fetchDataFirstPage(initialState)
        }}
          color={ColorType.SECONDARY}>{intl.formatMessage({id: "header_menu_clear_search"})}</Button>
      </div>
    </FilterGroup>
  )
}

export default StaffingReportingFilters;
